module.exports = __webpack_public_path__ + "img/bell_black.a791bedf.svg";